<div class="container">

    <!-- Banner Executive para usuarios Freemium - Desktop -->
    <div *ngIf="showSalaryBanner" class="executive-banner desktop-only">
        <div class="banner-content">
            <div class="banner-text">
                <h3>El 30% de personas que crea objetivos en su plan de vida logra su exito en 3 meses</h3>
                <p>Lleva tu plan de vida al siguiente nivel</p>
            </div>
            <button class="banner-button" (click)="scheduleInterviewFromBanner()">
                Quiero mi plan de vida
            </button>
            <button class="banner-close" (click)="closeExecutiveBanner()">
                ×
            </button>
        </div>
    </div>

    <!-- Banner Executive para usuarios Freemium - Mobile -->
    <div *ngIf="showSalaryBanner" class="executive-banner-mobile mobile-only">
        <div class="banner-mobile-content">
            <div class="banner-mobile-text">
                <h3>Inicia tu plan de vida, únete a {{ getPlanType() }}</h3>
            </div>
            <button class="banner-mobile-button" (click)="scheduleInterviewFromBanner()">
                Unirme a lista de espera
            </button>
            <button class="banner-mobile-close" (click)="closeExecutiveBanner()">
                ×
            </button>
        </div>
    </div>

    <!-- Info Bar -->
    <div class="info-bar">
        <div class="info-content">
            <i class="check-icon">✓</i>
            <span>Explora los resultados de tu rueda de vida y empieza a construir objetivos con sentido <a
                    style="font-weight: bold; text-decoration: underline; color: black; cursor: pointer;"
                    (click)="goToResults()">AQUÍ</a></span>
        </div>
    </div>

    <div class="header-title">
        <h4 class="section-title">Objetivos</h4>
        <!-- <p class="date-text">{{ dateToday }}</p> -->
        <p class="date-text">Revisa aqui la lista de tus objetivos. Dale clic a tus objetivos y visualiza tus
            actividades.</p>
    </div>

    <div class="header">
        <div class="actions">
            <!-- <button class="btn-action btn-secondary" (click)="toPRD()">
                <span class="btn-text">Ir a Priorización</span>
                <span class="btn-text-mobile">Priorización</span>
            </button> -->
            <button class="btn-action btn-tertiary" (click)="startDownloadPDF()">
                <span class="btn-text">Descargar PDF</span>
                <span class="btn-text-mobile">PDF</span>
                <img class="btn-icon" src="assets/icons/pdf.svg" alt="Icon">
            </button>
            <button class="btn-create btn-primary" (click)="createObjective()">
                <span class="btn-text">Crear nuevo</span>
                <span class="btn-text-mobile">Nuevo</span>
                <span class="btn-icon">+</span>
            </button>
        </div>
    </div>

    <div [@fade]="messageHide ? 'hidden' : 'visible'" class="info-message">
        <div class="message-content">
            <div class="message-icon">
                <span class="icon-info">ℹ️</span>
            </div>
            <div class="message-text">
                <p class="message-title">💡 Consejo</p>
                <p class="message-description">Completa la priorización con tu mentor para tener una mejor guía de qué
                    objetivos crear.</p>
            </div>
            <button class="message-close" (click)="hideMessage()" aria-label="Cerrar mensaje">
                <span class="icon-close">×</span>
            </button>
        </div>
    </div>

    <div class="table-objective">
        <app-table-objectives></app-table-objectives>
    </div>


</div>

<!-- Modal de Lista de Espera -->
<div *ngIf="showWaitlistModal" class="waitlist-modal-overlay">
    <div class="waitlist-modal" (click)="$event.stopPropagation()">
        <div class="waitlist-modal-content">
            <!-- Sección de Video -->
            <div class="video-section">
                <div class="video-container">
                    <!-- Usar nuestro componente reutilizable YouTube Player -->
                    <div #youtubePlayer>
                        <app-youtube-player *ngIf="getProfessionalVideoId()" [videoId]="getProfessionalVideoId()"
                            [params]="getVideoParams()"></app-youtube-player>
                    </div>

                    <!-- Mensaje de error si no hay video ID -->
                    <div *ngIf="!getProfessionalVideoId()" class="error-message">
                        <p>No se pudo cargar el video profesional</p>
                    </div>
                </div>
            </div>

            <!-- Header Text -->
            <div class="modal-header-text">
                <h2>Únete a nuestra lista de espera para convertirte en Phoenix {{ getPlanType() }}</h2>
                <p>Sé el primero en acceder a todas las increíbles actividades que tenemos para ti</p>
            </div>

            <!-- Formulario -->
            <form class="waitlist-form" (ngSubmit)="submitWaitlistForm()">
                <div class="form-row">
                    <div class="form-group">
                        <label>Nombre <span class="required">*</span></label>
                        <input type="text" [(ngModel)]="waitlistForm.nombre" name="nombre" placeholder="Ingrese nombre"
                            required>
                    </div>

                    <div class="form-group">
                        <label>Apellido <span class="required">*</span></label>
                        <input type="text" [(ngModel)]="waitlistForm.apellido" name="apellido"
                            placeholder="Ingrese apellido" required>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label>Teléfono <span class="required">*</span></label>
                        <input type="tel" [(ngModel)]="waitlistForm.telefono" name="telefono"
                            placeholder="Ingrese teléfono" required>
                    </div>

                    <div class="form-group">
                        <label>Correo electrónico <span class="required">*</span></label>
                        <input type="email" [(ngModel)]="waitlistForm.correoElectronico" name="correoElectronico"
                            placeholder="Ingrese correo" required>
                    </div>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <label>Provincia <span class="required">*</span></label>
                        <select [(ngModel)]="waitlistForm.provincia" name="provincia" (change)="onProvinciaChange()"
                            required>
                            <option value="">Ingrese provincia</option>
                            <option *ngFor="let provincia of provincias" [value]="provincia">
                                {{ provincia }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label>Distrito <span class="required">*</span></label>
                        <select [(ngModel)]="waitlistForm.distrito" name="distrito" [disabled]="!waitlistForm.provincia"
                            required>
                            <option value="">Ingrese distrito</option>
                            <option *ngFor="let distrito of getDistritosByProvincia()" [value]="distrito">
                                {{ distrito }}
                            </option>
                        </select>
                    </div>
                </div>

                <button type="submit" class="register-button"
                    [disabled]="!isWaitlistFormValid() || isSubmittingWaitlist">
                    <span *ngIf="!isSubmittingWaitlist">Registrarme</span>
                    <span *ngIf="isSubmittingWaitlist">Registrando...</span>
                </button>
            </form>

            <!-- Sección de Beneficios -->
            <div class="benefits-section">
                <h3>Descubre todo lo que Phoenix {{ getPlanType() }} tiene para ti</h3>
                <div class="benefits-list">
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Sesión grupal mensual para avanzar en comunidad</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Mentor digital 24/7 disponible para guiarte en cualquier momento.</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Crea tu plan de vida y define objetivos claros con seguimiento.</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Acceso completo al directorio de expertos.</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Acceso a la Academy con contenidos avanzados.</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Acceso a Phoenix Sessions</span>
                    </div>
                    <div class="benefit-item">
                        <span class="check-icon">✓</span>
                        <span>Rutas de reinvención y herramientas personalizadas para tu progreso.</span>
                    </div>
                </div>
            </div>

            <!-- Botón de cerrar -->
            <button class="close-button" (click)="closeWaitlistModal()">
                <span>×</span>
            </button>
        </div>
    </div>
</div>